<template>
  <template-dialog-wraper>
    <div class="container">
      <p class="t1">{{ $t('detailPage.vip.dialog.t1') }}</p>
      <p class="t2">{{ $t('detailPage.vip.dialog.t2') }}</p>
      <p class="t3">{{ $t('detailPage.vip.dialog.t3') }}</p>
      <div class="download flex">
        <div>
          <img src="https://static.loklok.video/img/dwercode220124.png?imageMogr2/format/webp" alt="loklok app download ercode" class="ercode" />
        </div>
        <ul class="flex">
          <!-- <li>
            <a class="google" :href="$attrs.googlePlay" target="_blank" @click="onDownload('googlePlay')"></a>
          </li> -->
          <li>
            <a class="apk" :href="$attrs.androidApk" target="_blank" @click="onDownload('apk')"></a>
          </li>
          <!-- <li>
            <a class="ios" :href="$attrs.appStore" target="_blank" @click="onDownload('ios')"></a>
          </li>
          <li>
            <a class="other-market" :href="$attrs.androidApk" target="_blank" @click="onDownload('other')"></a>
          </li> -->
        </ul>
      </div>
      <p class="t4" v-if="!Object.keys(userInfo).length" @click="handleLogin" v-html="$t('detailPage.vip.dialog.t4')"></p>
      <p class="t4" v-else @click="handleRefresh" v-html="$t('detailPage.vip.dialog.t5')"></p>
    </div>
  </template-dialog-wraper>
</template>
<script>
import TemplateDialogWraper from '~/components/dialog/TemplateDialogWraper.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'OpenVip',
  components: {
    TemplateDialogWraper
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {}
  },
  methods: {
    onDownload(type) {
      this.$buryEvent('下载按钮点击', { type: type })
    },
    handleRefresh(e) {
      if ([].includes.call(e.target.classList, 'active')) {
        location.reload()
      }
    },
    handleLogin(e) {
      if ([].includes.call(e.target.classList, 'active')) {
        this.$modal.hideAll()
        this.$showLoginDialogFunction()
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '~/styles/vars.sass';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $mainTextColor;
  text-align: center;
  .t1 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;
    margin-bottom: 40px;
  }
  .t2 {
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 150%;
    margin-bottom: 10px;
  }
  .t3 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    color: #999999;
    margin-bottom: 20px;
  }
  .t4 {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    :deep(.active) {
      cursor: pointer;
      color: #995aff;
    }
  }

  .download {
    width: 474px;
    margin-bottom: 40px;
  }
  .flex {
    display: flex;
    .ercode {
      width: 112px;
      height: 112px;
      margin-right: 20px;
      border-radius: 16px;
      padding: 10px;
      background-color: #fff;
    }
    ul {
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 160px;
        height: 45px;
        margin-bottom: 20px;
        a {
          display: block;
          width: 160px;
          height: 45px;
          background: url('https://static.loklok.video/img/下载按钮.png?imageMogr2/format/webp') no-repeat;
          background-size: cover;
          &.apk {
            background-position: left top;
          }
          &.google {
            background-position: left -45px;
          }
          &.ios {
            background-position: left -90px;
          }
          &.other-market {
            background-position: left bottom;
          }
        }
      }
    }
  }
}
</style>
